// Consolidated from 7 widget pagination containers' onChangePageString (docs/plans/
// consolidate-duplicate-functions-fsd, W4/C7). Only the clamp-to-maxPageNumber behavior (1
// container clamps, 6 don't) and the optional setIsRenderViewerEcg side effect (4 call it, 3
// don't) vary across callers.
export const parsePageInput = (value: any, maxPageNumber?: number) =>
  typeof maxPageNumber === 'number' && value > maxPageNumber ? maxPageNumber : value;

export const createOnChangePageString =
  ({
    maxPageNumber,
    setIsError,
    setPageString,
    pageStringRef,
    setInputSize,
    setIsRenderViewerEcg,
  }: {
    maxPageNumber?: number;
    setIsError: (value: boolean) => void;
    setPageString: (value: any) => void;
    pageStringRef: { current: any };
    setInputSize: (value: any) => void;
    setIsRenderViewerEcg?: (value: boolean) => void;
  }) =>
  (name: any, value: any, size: any) => {
    const newValue = parsePageInput(value, maxPageNumber);
    setIsError(false);
    setPageString(newValue);
    pageStringRef.current = newValue;
    setInputSize(size);
    setIsRenderViewerEcg?.(true);
  };
